<mat-list>
  <mat-list-item>
    <sn-icon fontSet="fa" [fontIconUnicode]="location.type.icon" matListIcon></sn-icon>
    <div matLine>{{ location.name }}</div>
    <div matLine class="fs-text-secondary">{{ 'common.name' | t }}</div>
  </mat-list-item>
  <mat-list-item>
    <sn-icon matListIcon>place</sn-icon>
    <div matLine [innerHtml]="location.addressToHtml()"></div>
    <div matLine class="fs-text-secondary">{{ 'common.address' | t }}</div>
  </mat-list-item>
  <mat-list-item>
    <sn-icon matListIcon>gps_fixed</sn-icon>
    <div matLine>{{ location.geometry | geometryToString }}</div>
    <div matLine class="fs-text-secondary">{{ 'locations.fields.coordinates' | t }}</div>
  </mat-list-item>
  <ng-container *ngIf="location.geometry">
    <sn-location-map class="location-map" [location]="location"></sn-location-map>
  </ng-container>
  <div mat-subheader *ngIf="location.hasContact">{{ 'locations.fields.contactInformation' | t }}</div>
  <mat-list-item *ngIf="location.contactName">
    <sn-icon matListIcon>person</sn-icon>
    <div matLine>{{ location.contactName }}</div>
    <div matLine class="fs-text-secondary">{{ 'common.name' | t }}</div>
  </mat-list-item>
  <mat-list-item *ngIf="location.contactEmail">
    <sn-icon matListIcon>email</sn-icon>
    <div matLine>{{ location.contactEmail }}</div>
    <div matLine class="fs-text-secondary">{{ 'common.email' | t }}</div>
  </mat-list-item>
  <mat-list-item *ngIf="location.contactPhone">
    <sn-icon matListIcon>phone</sn-icon>
    <div matLine>{{ location.contactPhone }}</div>
    <div matLine class="fs-text-secondary">{{ 'common.phone' | t }}</div>
  </mat-list-item>
  <div mat-subheader>{{ 'common.tags' | t }}</div>
  <mat-list-item class="tag-list">
    <sn-icon matListIcon>local_offer</sn-icon>
    <sn-tag-edit-list
      matLine
      [tags]="location.tags"
      [canChange]="location.canEdit"
      [contentType]="tagContentType"
      (tagsChanged)="onTagsChanged($event)"
    >
    </sn-tag-edit-list>
  </mat-list-item>
</mat-list>
